// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#change_language_modal .bb-select-options {\n  height: auto;\n}\n\n/*\nResponsive\n*/\n@media (max-width: 992px) {\n#change_language_modal .modal-content {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n}", ""]);
// Exports
module.exports = exports;
